import { MeteringTimeseriesDTO } from '../dtos/metering';
import { MeteringTimeseriesItem, MeteringTimeseriesMap } from '../models/metering';

export const meteringTimeseriesDTOToTimeseriesData = (
  meteringTimeseries: MeteringTimeseriesDTO
): MeteringTimeseriesMap => {
  const tsMap: MeteringTimeseriesMap = {};
  return meteringTimeseries.reduce((prev, cur) => {
    Object.keys(cur.result).forEach(key => {
      const seriesItem = {
        timestamp: cur.timestamp,
        name: key,
        value: cur.result[key],
        min: (cur.result[key] / 60).toFixed(1),
        km: (cur.result[key] / 1000).toFixed(1)
      };
      if (!prev[key] || !Array.isArray(prev[key])) {
        prev[key] = [];
      }
      prev[key].push(seriesItem);
    });
    return prev;
  }, tsMap);
};

export const meteringTimeseriesItemNameTransform = (newName: string) => {
  return (item: MeteringTimeseriesItem) => ({
    name: newName,
    value: item.value,
    timestamp: item.timestamp
  });
};
